export default "__VITE_ASSET__61cfd83a__"